import { Injectable, computed, signal } from '@angular/core';

export interface OverlayPosition {
  top: number;
  left: number;
  width: number;
  height: number;
}

@Injectable({ providedIn: 'root' })
export class VictoriaLogsOverlayService {
  open = signal(false);
  minimized = signal(false);
  maximized = signal(false);
  position = signal<OverlayPosition | null>(null);
  // True when the iframe is on screen (open + not minimized). Native trlog content
  // hides while this is true so we don't run two log streams in parallel.
  visible = computed(() => this.open() && !this.minimized());

  minimize() {
    this.minimized.set(true);
  }

  restore() {
    this.minimized.set(false);
  }

  maximize() {
    this.maximized.set(true);
  }

  unmaximize() {
    this.maximized.set(false);
  }

  updatePosition(pos: OverlayPosition) {
    this.position.set(pos);
  }

  reset() {
    this.minimized.set(false);
    this.maximized.set(false);
    this.position.set(null);
  }
}
